class CartDrawer extends HTMLElement {
	constructor() {
		super();

		this.setHeaderCartIconAccessibility();

		const queryString = window.location.search;
		const urlParams = new URLSearchParams(queryString);
		const product = urlParams.get('cart');

		if (product == 'true') {
			this.open();
		}
	}

	toggleNote() {
		this.noteFakeField.innerHTML = this.textAreaNote.value;
		this.btnDeleteNote.classList.toggle('u-hidden');
		this.textAreaNote.classList.toggle('u-hidden');
		this.noteFakeField.classList.toggle('u-hidden');

		this.btnsValidNote.forEach((btn) => {
			btn.classList.toggle('u-hidden');
		});
	}

	deleteNote() {
		document.querySelector('[data-note-display]').checked = false;
    document.querySelector('[data-note-content]').classList.add('u-hidden');
		this.textAreaNote.value = this.noteFakeField.innerHTML = '';
		this.noteCountLabel.innerHTML = '0';
    // Push an empty cart note
		const body = JSON.stringify({note: ''});
		fetch(`${routes.cart_update_url}`, {...fetchConfig(), ...{body}});
	}

	setHeaderCartIconAccessibility() {
		const cartLink = document.querySelectorAll('cart__bubble');
		cartLink.forEach((el) => {
			el.setAttribute('role', 'button');
			el.setAttribute('aria-haspopup', 'dialog');
			el.addEventListener('click', (event) => {
				event.preventDefault();
				this.open(el);
			});
			el.addEventListener('keydown', (event) => {
				if (event.code.toUpperCase() === 'SPACE') {
					event.preventDefault();
					this.open(el);
				}
			});
		});
	}

	open(triggeredBy) {
		if (triggeredBy) this.setActiveElement(triggeredBy);
		const cartDrawerNote = this.querySelector('[id^="Details-"] summary');
		if (cartDrawerNote && !cartDrawerNote.hasAttribute('role'))
			this.setSummaryAccessibility(cartDrawerNote);
		// here the animation doesn't seem to always get triggered. A timeout seem to help
		setTimeout(() => {
			this.classList.add('animate', 'is-visible');
			document.querySelector('#cart').classList.add('is-visible');
		});
	}

	close() {
		this.classList.remove('is-visible');
		removeTrapFocus(this.activeElement);
	}

	setSummaryAccessibility(cartDrawerNote) {
		cartDrawerNote.setAttribute('role', 'button');
		cartDrawerNote.setAttribute('aria-expanded', 'false');

		if (cartDrawerNote.nextElementSibling.getAttribute('id')) {
			cartDrawerNote.setAttribute(
				'aria-controls',
				cartDrawerNote.nextElementSibling.id,
			);
		}

		cartDrawerNote.addEventListener('click', (event) => {
			event.currentTarget.setAttribute(
				'aria-expanded',
				!event.currentTarget.closest('details').hasAttribute('open'),
			);
		});

		cartDrawerNote.parentElement.addEventListener('keyup', onKeyUpEscape);
	}

	renderContents(parsedState) {
		this.cartItemKey = parsedState.key;
		this.productId = parsedState.id;
		this.getSectionsToRender().forEach((section) => {
			const sectionElement = section.selector
				? document.querySelector(section.selector)
				: document.getElementById(section.id);
			if (sectionElement) {
				sectionElement.innerHTML = this.getSectionInnerHTML(
					parsedState.sections[section.id],
					section.selector,
				);
			}
		});

		const updateCart = new CustomEvent('updateCart');
		document.dispatchEvent(updateCart);

		setTimeout(() => {
			this.open();
		});
	}

	getSectionInnerHTML(html, selector = '.shopify-section') {
		return new DOMParser()
			.parseFromString(html, 'text/html')
			.querySelector(selector).innerHTML;
	}

	getSectionsToRender() {
		return [
			{
				id: 'cart-drawer',
				selector: '.drawer__count',
			},
			{
				id: 'cart-drawer',
				selector: '#CartDrawer-CartItems',
			},
			{
				id: 'cart-drawer',
				selector: '.drawer__content',
			},
			{
				id: 'cart-drawer',
				selector: '#CartDrawer-Checkout',
			}
		];
	}

	getSectionDOM(html, selector = '.shopify-section') {
		return new DOMParser()
			.parseFromString(html, 'text/html')
			.querySelector(selector);
	}

	setActiveElement(element) {
		this.activeElement = element;
	}
}

customElements.define('cart-drawer', CartDrawer);

class CartDrawerItems extends CartItems {
	getSectionsToRender() {
		return [
			{
				id: 'CartDrawer',
				section: 'cart-drawer',
				selector: '.drawer__content',
			},
			{
				id: 'CartDrawer',
				section: 'cart-drawer',
				selector: '#CartDrawer-Checkout',
			},
			{
				id: 'cart',
				section: 'cart-drawer',
				selector: '.drawer__count',
			}
		];
	}
}

customElements.define('cart-drawer-items', CartDrawerItems);
